
const menuData = [{
  name: 'Tenants',
  icon: 'home',
  path: 'tenant',
},
{
  name: 'Admins',
  icon: 'user',
  path: 'admin',
},
];

export default menuData;



// WEBPACK FOOTER //
// ./src/common/menu.js